import React, { useState } from 'react';
import './App.css';
import logoImg from './assets/tecin-removebg-preview.png';
import binotechEye from './assets/AI_banner.png';
import YogaDemo from './YogaDemo';
import YogaDashboard from './YogaDashboard';
import AIExperienceCenter from './AIExperienceCenter';
const aiProducts = [
  {
    id: "1.1",
    category: "Pose Estimation",
    title: "YogaFit App (باشگاه یوگا)",
    description: "یک مربی هوشمند یوگا که با دوربین معمولی، حرکت بدن را به‌صورت دقیق تحلیل می‌کند، اشتباهات حرکتی را تشخیص می‌دهد و بازخورد شخصی‌سازی‌شده ارائه می‌دهد. این پلتفرم یک موتور تحلیل حرکت انسانی است که از ورزش تا فیزیوتراپی کاربرد دارد.",
    tag: "Human Motion Intelligence",
    isDemoAvailable: true
  },
  {
    id: "1.2",
    category: "Pose Estimation",
    title: "ErgoAI (مدیر هوشمند HSE)",
    description: "سیستمی که ارگونومی را به‌صورت ۲۴ ساعته پایش می‌کند. با دوربین معمولی حرکات بدن کارکنان را تحلیل کرده، ریسک آسیب‌های اسکلتی–عضلانی را بر اساس RULA Score محاسبه می‌کند و هشدار بلادرنگ می‌دهد.",
    tag: "HSE & Ergonomics"
  },
  {
    id: "1.3",
    category: "Pose Estimation",
    title: "SafeSightAI (نظارت بر ایمنی)",
    description: "سیستم هوش مصنوعی که نه‌تنها استفاده از تجهیزات ایمنی (PPE) مانند کلاه و جلیقه را تشخیص می‌دهد، بلکه رفتارهای پرخطر را شناسایی کرده و قبل از وقوع حادثه گزارش مدیریتی ارائه می‌دهد.",
    tag: "Safety AI"
  },
  {
    id: "2.0",
    category: "Anomaly Detection",
    title: "SentinelQC (کنترل کیفیت هوشمند)",
    description: "سیستم هوشمند شناسایی آنومالی و فرسودگی قطعات در خط تولید. تشخیص قطعات معیوب، محل دقیق خرابی و یادگیری با تعداد نمونه کم جهت تضمین کیفیت و کاهش خطای انسانی.",
    tag: "Computer Vision"
  },
  {
    id: "3.0",
    category: "Speech AI",
    title: "Offline Speech-to-Text & Automation",
    description: "سیستم هوشمند آفلاین تبدیل صوت به متن با دقت بالا و شناسایی کلیدواژه‌های حیاتی جهت اتوماسیون اقدامات (مانند ثبت تیکت خودکار) بدون نیاز به اینترنت و هزینه‌های API خارجی.",
    tag: "NLP & Voice"
  }
];

const companyServices = [
  { code: "3110340", title: "خدمات رایانه‌ای و محیط‌های اطلاعاتی", desc: "طراحی و ایجاد محیط‌های اطلاعاتی بر روی شبکه‌های داخلی و جهانی (طراحی صفحات وب)", share: "۲۵٪" },
  { code: "3110310", title: "مشاوره و پشتیبانی سیستم‌ها", desc: "ارائه خدمات رایانه‌ای نظیر مشاوره، تهیه نقشه، طرح و یا اجرا و پشتیبانی سیستم‌های رایانه‌ای", share: "۱۵٪" },
  { code: "3110320", title: "برنامه‌نویسی و پردازش داده‌ها", desc: "خدمات برنامه‌نویسی، پردازش داده‌ها، تولید و صدور کارت‌های مغناطیسی", share: "۱۰٪" },
  { code: "1130030", title: "تولید انواع نرم‌افزار", desc: "تولید تخصصی انواع نرم‌افزارهای کاربردی و پلتفرمی", share: "۱۵٪" },
  { code: "1130050", title: "تولید نرم‌افزار موجب قرارداد", desc: "تولید انواع نرم‌افزار سفارشی بر اساس نیازسنجی دقیق سازمان‌ها", share: "۱۵٪" },
  { code: "2130033", title: "بازرگانی و خرده‌فروشی نرم‌افزار", desc: "توزیع و فروش انواع نرم‌افزار (تولید داخل)", share: "۱۰٪" }
];

function App() {
  const [activeTab, setActiveTab] = useState('all');
  const [showYogaDemo, setShowYogaDemo] = useState(false);

  const filteredProducts = activeTab === 'all'
    ? aiProducts
    : aiProducts.filter(p => p.category === activeTab);

  // وضعیت رندر شدن پنل اختصاصی یوگا مجهز به دموی لایو در بالاترین قسمت آن
  if (showYogaDemo) {
    return (
      <YogaDashboard onBackToMain={() => setShowYogaDemo(false)}>
        <YogaDemo />
      </YogaDashboard>
    );
  }

  return (
    <div className="app-container" dir="rtl">
      <header className="navbar">
        <div className="logo-section">
          <img
            src={logoImg}
            alt="بینوتک"
            style={{
              height: '150px',
              width: 'auto',
              maxWidth: '200px',
              objectFit: 'contain',
              display: 'block'
            }}
          />
        </div>
        <nav className="nav-links">
          <a href="#hero">خانه</a>
          <a href="#ai-products">محصولات هوش مصنوعی</a>
          <a href="#services">حوزه‌های فعالیت</a>
          <a href="#about">درباره ما</a>
        </nav>
      </header>

      <section id="hero" className="hero-section">
        <div className="hero-content">
          <div className="badge">پلتفرم‌های نسل جدید هوش مصنوعی</div>
          <h2>آینده را با <span>بینش هوشمند</span> تماشا کنید</h2>
          <p>
            شرکت سهامی خاص بینش و نوآوری تکین (بینوتک) توسعه‌دهنده راهکارهای پیشرفته بینایی ماشین، تحلیل حرکت انسانی (Pose Estimation) و پردازش گفتار به صورت کاملاً بومی و سازمانی.
          </p>
          <div className="hero-cta">
            <a href="#ai-products" className="btn-primary">مشاهده محصولات AI</a>
            <a href="#services" className="btn-secondary">خدمات و مجوزها</a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hologram-container big-zone">
            <img
              src={binotechEye}
              alt="بینوتک - بینایی ماشین و هوش مصنوعی"
              className="hologram-banner dynamic-zoom"
            />
            <div className="hologram-glow-base"></div>
          </div>
        </div>
      </section>

      <section id="ai-products" className="products-section">
        <div className="section-title">
          <h1>محصولات لبه تکنولوژی هوش مصنوعی</h1>
          <p>راهکارهای هوشمند بر پایه پردازش تصویر و صوت برای ارتقای کسب‌وکار شما</p>
        </div>

        <div className="filter-bar">
          <button className={activeTab === 'all' ? 'active' : ''} onClick={() => setActiveTab('all')}>همه محصولات</button>
          <button className={activeTab === 'Pose Estimation' ? 'active' : ''} onClick={() => setActiveTab('Pose Estimation')}>تحلیل حرکت (Pose)</button>
          <button className={activeTab === 'Anomaly Detection' ? 'active' : ''} onClick={() => setActiveTab('Anomaly Detection')}>کنترل کیفیت (QC)</button>
          <button className={activeTab === 'Speech AI' ? 'active' : ''} onClick={() => setActiveTab('Speech AI')}>پردازش گفتار (Voice)</button>
        </div>

        <div className="products-grid">
          {filteredProducts.map((product) => (
            <div 
              key={product.id} 
              className={`product-card ${product.isDemoAvailable ? 'demo-card-highlight' : ''}`}
              onClick={() => product.isDemoAvailable && setShowYogaDemo(true)}
              style={{ cursor: product.isDemoAvailable ? 'pointer' : 'default' }}
            >
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              {product.isDemoAvailable && <span className="demo-badge">ورود به محیط آزمایشگاه ←</span>}
            </div>
          ))}
        </div>
      </section>

      {/* ─── بهترین مکان: مرکز تجربه هوش مصنوعی بینوتک ─── */}
      <section id="experience-center" style={{ padding: '60px 8%', backgroundColor: '#0c0d12' }}>
        {/* <AIExperienceCenter /> */}
      </section>

      <section id="services" className="services-section">
        <div className="section-title">
          <h2>ساختار فعالیت و خدمات بینوتک</h2>
          <p>سهم فعالیت‌های طراحی، تولیدی و بازرگانی شرکت بر اساس مجوزهای رسمی</p>
        </div>

        <div className="services-grid">
          {companyServices.map((service, index) => (
            <div key={index} className="service-table-card">
              <div className="service-header"></div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section id="about" style={{ padding: '80px 8%', background: '#0b0b0f', borderTop: '1px solid rgba(122, 34, 255, 0.1)' }}>
        <div className="section-title">
          <h2>درباره بینوتک</h2>
          <p>تلفیق دانش، بینش و نوآوری در عصر هوش مصنوعی</p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', marginBottom: '50px' }}>
          <div className="product-card">
            <div style={{ fontSize: '28px', marginBottom: '15px', color: '#7a22ff' }}>🎯</div>
            <h3 style={{ color: '#fff', marginBottom: '10px' }}>ماموریت ما</h3>
            <p style={{ color: '#94a3b8', fontSize: '0.95rem', lineHeight: '1.7', textAlign: 'justify' }}>
              توسعه راهکارهای بومی و کاربردی بر پایه هوش مصنوعی و بینایی ماشین جهت هوشمندسازی فرآیندهای صنعتی، نظارتی و ارتقای ایمنی محیط‌های کاری.
            </p>
          </div>

          <div className="product-card">
            <div style={{ fontSize: '28px', marginBottom: '15px', color: '#7a22ff' }}>👁️</div>
            <h3 style={{ color: '#fff', marginBottom: '10px' }}>چشم‌انداز</h3>
            <p style={{ color: '#94a3b8', fontSize: '0.95rem', lineHeight: '1.7', textAlign: 'justify' }}>
              رهبری بازار پلتفرم‌های تحلیل حرکت انسانی، تشخیص آنومالی خطوط تولید و پردازش هوشمند تصویر در لبه تکنولوژی جهانی.
            </p>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '25px',
          paddingTop: '40px',
          borderTop: '1px solid rgba(122, 34, 255, 0.15)'
        }}>
          <div style={{ display: 'flex', gap: '15px', background: 'rgba(255, 255, 255, 0.01)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.02)' }}>
            <div style={{ background: 'rgba(122, 34, 255, 0.1)', padding: '8px', borderRadius: '10px', height: '44px', width: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7a22ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <div>
              <h4 style={{ color: '#fff', fontSize: '15px', marginBottom: '6px' }}>آدرس شرکت</h4>
              <p style={{ color: '#94a3b8', fontSize: '13.5px', lineHeight: '1.6' }}>البرز، کرج، بلوار طالقانی، کوچه شجاعی، ساختمان تخت جمشید</p>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px', background: 'rgba(255, 255, 255, 0.01)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.02)' }}>
            <div style={{ background: 'rgba(122, 34, 255, 0.1)', padding: '8px', borderRadius: '10px', height: '44px', width: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7a22ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <div>
              <h4 style={{ color: '#fff', fontSize: '15px', marginBottom: '6px' }}>تلفن‌های تماس</h4>
              <p dir="ltr" style={{ color: '#94a3b8', fontSize: '13.5px', textAlign: 'right' }}>+98 (26) 3255-9525</p>
              <p dir="ltr" style={{ color: '#94a3b8', fontSize: '13.5px', textAlign: 'right' }}>+98 (919) 026-1037</p>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px', background: 'rgba(255, 255, 255, 0.01)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.02)' }}>
            <div style={{ background: 'rgba(122, 34, 255, 0.1)', padding: '8px', borderRadius: '10px', height: '44px', width: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7a22ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <div>
              <h4 style={{ color: '#fff', fontSize: '15px', marginBottom: '6px' }}>پست الکترونیک</h4>
              <p style={{ color: '#94a3b8', fontSize: '13.5px' }}>info@binotech.ai</p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-bottom">
          <p>© ۲۰۲۶ شرکت بینوتک. تمامی حقوق محفوظ است.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;